import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'core-collapsible-menu',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  templateUrl: './collapsible-menu.component.html',
  styleUrls: ['./collapsible-menu.component.scss'],
})
export class CollapsibleMenuComponent {
  @Input() id: number = 0;
  @Input() title: string = '';
  @Input() isOpen: boolean = false;
  @Input() collapsed: boolean = false;

  @Output() activeMenuEvent  = new EventEmitter<number>();

  onToggleClick(): void {
    if (this.collapsed) {
      return;
    }

    this.activeMenuEvent.emit(this.id);
  }
}
